import OptSend from "./OptSend";
import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import orderServices from "../../api-service/order-service";
import Visibility from "../utils/Visibility";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
export const BrowseProducts = ({ params, t, className }: any) => {
  return (
    <Link to={`/${params.domain}/${params.branch_id}`}>
      <button className={`bg-primary text-onPrimary px-4 py-2 md:px-5 md:py-2.5 rounded-lg font-semibold text-sm md:text-base hover:bg-primary/90 shadow-md hover:shadow-lg transition-all duration-300 ${className || ""}`}>
        {t("gloabl.browseProducts")}
      </button>
    </Link>
  );
};

export const CheckoutComponent = ({
  cartItems,
  total,
  t,
  params,
  loadCart,
}: any) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [note, setNote] = useState("");
  const [openOptSheet, setOpenOptSheet] = useState(false);
  const tokenOrder = localStorage.getItem("tokenOrder" + params.branch_id);
  const items = cartItems.map((item: any) => ({
    product_id: item.id,
    amount: item.amount,
    sub_option_id: item.option
      ? item.option.map((opt: any) => opt.subOption.id)
      : [],
    note: item.note || "",
  }));
  // const navigate = useNavigate();

  const isValidPhoneNumber = (phone: string) => {
    const phoneRegex = /^[0-9]{10,15}$/;
    return phoneRegex.test(phone);
  };
  const handleCheckout = async () => {
    if (!name || !phone) {
      if (!name || !phone) {
        toast.error(t("gloabl.phoneOrName"), {
          className: "bg-red-500 text-white rounded-lg shadow-lg",
          hideProgressBar: true,
        });
        return;
      }
      if (!isValidPhoneNumber(phone)) {
        toast.error(
          t("gloabl.phoneInvalid", {
            className: "bg-red-500 text-white rounded-lg shadow-lg",
            hideProgressBar: true,
          })
        );
        return;
      }
      // try {
      //   const otp = await orderServices
      //     .requestOtp({ phone: phone })
      //     .then((otp) => {
      //       setOpenOptSheet(true);
      //     });
      // } catch (error) {
      //   toast.error(t("gloabl.orderError"));
      // }
    } else {
      try {
        const table_id = sessionStorage.getItem("tableId");
        orderServices
          .storeOrder({
            domain: params.domain,
            // token: tokenOrder,
            items: items,
            note: note,
            table_id: table_id || 1,
            branch_id: params.branch_id,
            tenant_id: 1,
            customer_id: 1,
            nameCustomer: name,
            phoneCustomer: phone,
            // tenant_id: params.table_id ||1|| null,
            // customer_id: 1,
            success_url: `${origin}/${params.domain}/${params.branch_id}/orders?confirm_payment=true`,
            cancel_url: `${origin}/${params.domain}/${params.branch_id}/cart`,
          })
          .then((res) => {
            // toast.success(
            //   `${t("gloabl.orderSuccess")} # ${res.data.data.order_id}`,
            //   {
            //     onClick: () => {
            //       navigate(`/${params.domain}/${params.branch_id}/orders`);
            //     },
            //   }
            // );
            // if (!Cookies.get(`phone${params.branch_id}`)) {
            //   const towHourFromNow = new Date(
            //     new Date().getTime() + 2 * 60 * 60 * 1000
            //   );
            //   Cookies.set(`phone${params.branch_id}`, res.data.phone, {
            //     expires: towHourFromNow,
            //   });
            // }
            localStorage.setItem(
              "tokenOrder" + params.branch_id,
              res.data.phone
            );

            window.location.href = res.data.url;
            setName("");
            setPhone("");
            setNote("");
            // localStorage.removeItem(`cart${params.branch_id}`);
            // loadCart();
            // window.dispatchEvent(new Event("cart-updated"));
          })
          .catch((err) => toast.error(t("gloabl.orderError")));
      } catch (error) {
        toast.error(t("gloabl.orderError"), {
          className: "bg-red-500 text-white rounded-lg shadow-lg",
          hideProgressBar: true,
        });
      }
    }
  };
  return (
    <div className="flex flex-col gap-4 md:gap-5 mt-4 p-4 md:p-5 bg-card rounded-xl border border-border/50 shadow-md">
      {/* Customer Info */}
      <div className="space-y-3 md:space-y-4">
        <h3 className="text-lg md:text-xl font-bold text-foreground">
          {t("gloabl.orderDetails")}
        </h3>
        
        <input
          type="text"
          placeholder={t("contact.name")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full px-4 py-2.5 md:py-3 border-2 border-border rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
        />
        
        <div dir="ltr">
          <PhoneInput
            defaultCountry="AE"
            value={phone}
            onChange={(value) => setPhone(value as string)}
            placeholder={t("contact.phone")}
            international
            countryCallingCodeEditable={true}
            displayInitialValueAsLocalNumber={true}
            className="w-full px-4 py-2.5 md:py-3 border-2 border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
          />
        </div>

        <textarea
          placeholder={t("gloabl.addNote")}
          rows={3}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="w-full px-4 py-2.5 md:py-3 border-2 border-border rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none transition-all duration-300"
        ></textarea>
      </div>

      {/* Total Price */}
      <div className="flex items-center justify-between p-3 md:p-4 bg-muted/50 rounded-lg border border-border/50">
        <p className="text-base md:text-lg font-semibold text-foreground">
          {t("gloabl.totalPrice")}:
        </p>
        <p className="flex items-center gap-1 text-lg md:text-xl font-bold text-primary">
          <UAEDirhamIcon className="w-4 h-4 md:w-5 md:h-5" />
          {total}
        </p>
      </div>

      {/* Checkout Button */}
      <button
        onClick={() => handleCheckout()}
        type="button"
        className="w-full text-onPrimary bg-primary rounded-xl hover:bg-primary/90 focus:ring-4 focus:outline-none focus:ring-primary/50 font-semibold text-base md:text-lg px-5 py-3 md:py-3.5 text-center shadow-md hover:shadow-lg transition-all duration-300"
      >
        {t("gloabl.checkout")}
      </button>
      <OptSend
        openOptSheet={openOptSheet}
        setOpenOptSheet={setOpenOptSheet}
        phone={phone}
        setPhone={setPhone}
        setName={setName}
        setNote={setNote}
        loadCart={loadCart}
        name={name}
        note={note}
        cartItems={items}
        branch_id={params.branch_id}
      />
    </div>
  );
};
